export default function CoinIcon({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <mask
        id="mask0_coin_upsell"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="5"
        width="37"
        height="36"
      >
        <path fillRule="evenodd" clipRule="evenodd" d="M5.625 5.625H41.0874V40.6492H5.625V5.625Z" fill="white" />
      </mask>
      <g mask="url(#mask0_coin_upsell)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.625 23.1371C5.625 13.4656 13.5636 5.625 23.356 5.625C33.1489 5.625 41.0875 13.4656 41.0875 23.1371C41.0875 32.8086 33.1489 40.6492 23.356 40.6492C13.5636 40.6492 5.625 32.8086 5.625 23.1371Z"
          fill="#FFD715"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.30786 23.1371C8.30786 14.9288 15.045 8.27444 23.3559 8.27444C31.6672 8.27444 38.4043 14.9288 38.4043 23.1371C38.4043 31.3454 31.6672 37.9998 23.3559 37.9998C15.045 37.9998 8.30786 31.3454 8.30786 23.1371Z"
        fill="#FFCC01"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.2294 10.4521C32.7279 12.7628 33.5967 15.5099 33.5967 18.4576C33.5967 26.6658 26.8595 33.3198 18.5482 33.3198C15.6621 33.3198 12.9658 32.5167 10.6755 31.1251C13.3501 35.2488 18.0299 37.9823 23.3563 37.9823C31.6671 37.9823 38.4043 31.3279 38.4043 23.1196C38.4043 17.7618 35.5338 13.0672 31.2294 10.4521Z"
        fill="#F4AA2A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9439 24.4969C10.9439 17.251 16.8911 11.3772 24.2276 11.3772C28.5159 11.3772 32.3287 13.3846 34.7574 16.4993C32.4636 12.5665 28.1646 9.91882 23.239 9.91882C15.9025 9.91882 9.95532 15.7926 9.95532 23.0385C9.95532 26.0486 10.9827 28.8221 12.7091 31.0361C11.5861 29.111 10.9439 26.8781 10.9439 24.4969Z"
        fill="#FFF9E1"
      />
      <path
        d="M26.4083 16.882C26.493 16.8599 26.5323 16.892 26.5831 16.9528C26.8734 17.3016 27.8082 18.5184 28.0627 18.8512C28.0812 18.8747 28.0894 18.9057 28.085 18.9361C28.0806 18.9665 28.0639 18.9937 28.0395 19.0101C26.1548 20.5816 24.0585 22.8044 22.8895 24.396C22.8645 24.4298 22.8853 24.4324 22.9018 24.4249C24.9378 23.4886 29.7184 21.9952 31.875 21.5764L31.8744 24.7952C29.5697 25.2135 22.6816 27.4012 19.5506 29.1242C19.4914 29.1644 19.4135 29.152 19.3677 29.0954L17.7938 27.0927C17.75 27.0384 17.7466 27.0096 17.8022 26.921C19.0178 25.0158 21.5 22.052 23.0827 20.7961C23.1109 20.774 23.1033 20.7528 23.0704 20.7644C21.4213 21.3402 16.7345 23.4911 15 24.5396V21.8471C17.6179 20.185 23.6675 17.6124 26.4083 16.882Z"
        fill="white"
      />
    </svg>
  );
}
